import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, tap } from 'rxjs';
import { ContactActions } from './contact.actions';

@Injectable({
  providedIn: 'root'
})
export class ContactEffects {
  sendContactEffect$: Observable<Action> = createEffect(
    (): any =>
      this.actions$.pipe(
        ofType(ContactActions.submitSuccess),
        tap(() => {})
      ),
    { dispatch: false }
  );

  constructor(private actions$: Actions) {}
}
